'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _GEHelper = require("../../graphicEngine/GEHelper");
var _GEDragHelper = require("../../graphicEngine/GEDragHelper");
var _CloudVariable = _interopRequireDefault(require("../../extensions/CloudVariable"));
var _throttle2 = _interopRequireDefault(require("lodash/throttle"));
var _binPacking = _interopRequireDefault(require("../../util/binPacking"));
var VariableBP = new _binPacking["default"](460, 250);
var bpReplace = (0, _throttle2["default"])(VariableBP.replace.bind(VariableBP));

/**
 * 기본 변수블록 객체
 * @param {Object} variable variableMetadata
 */
var Variable = /*#__PURE__*/function () {
  function Variable(variable) {
    (0, _classCallCheck2["default"])(this, Variable);
    Entry.assert(typeof variable.name === 'string', 'Variable name must be given');
    /** @type {string} */
    this.name_ = variable.name;
    /** @type {string} */
    this.id_ = variable.id ? variable.id : Entry.generateHash();
    this.type = variable.variableType || 'variable';
    /** @type {entry object.id} */
    this.object_ = variable.object || null;
    /** @type {boolean} */
    this.isCloud_ = variable.isCloud || false;
    this.isRealTime_ = variable.isRealTime || false;
    this.cloudDate = variable.cloudDate || false;
    this.cloudVariable = _CloudVariable["default"].getInstance();
    this._nameWidth = null;
    this._valueWidth = null;

    /** @type {number||string} */
    var parsedValue = Entry.parseNumber(variable.value);
    if (typeof parsedValue === 'number') {
      this.value_ = parsedValue;
    } else if (!variable.value) {
      this.value_ = 0;
    } else {
      this.value_ = variable.value;
    }
    if (!variable.isClone) {
      /** @type {boolean} */
      this.visible_ = variable.visible || typeof variable.visible === 'boolean' ? variable.visible : true;
      /** @type {number} */
      this.x_ = variable.x ? variable.x : null;
      /** @type {number} */
      this.y_ = variable.y ? variable.y : null;
      var fontFamily = EntryStatic.fontFamily || "NanumGothic, 'Nanum Gothic'";
      this.BORDER = 6;
      this.FONT = "10pt ".concat(fontFamily);
      this.VALUE_FONT = "9pt ".concat(fontFamily);
    }
    Entry.addEventListener('workspaceChangeMode', this.updateView.bind(this));
  }

  /**
   * Generate variable view on canvas
   * @param {number} variableIndex index of this variable for render position
   */
  return (0, _createClass2["default"])(Variable, [{
    key: "RECT_RADIUS",
    get: function get() {
      return 7;
    }
  }, {
    key: "GL_VAR_POS",
    get: function get() {
      return {
        VALUE_Y: -8.5,
        LABEL_Y: -9.5
      };
    }
  }, {
    key: "GL_LIST_POS",
    get: function get() {
      return {
        INDEX_Y: 5,
        VALUE_Y: 6
      };
    }
  }, {
    key: "generateView",
    value: function generateView(variableIndex) {
      var type = this.type;
      if (type === 'variable' || type === 'timer' || type === 'answer' || type === 'stt') {
        this.view_ = _GEHelper.GEHelper.newContainer();
        this.rect_ = _GEHelper.GEHelper.newGraphic();
        this.view_.addChild(this.rect_);
        this.view_.variable = this;
        this.view_.visible = this.visible_;
        this.view_.mouseEnabled = true;
        _GEDragHelper.GEDragHelper.handleDrag(this.view_);

        // Stage 의 변수박스를 만든다.
        this.wrapper_ = _GEHelper.GEHelper.newGraphic();
        this.view_.addChild(this.wrapper_);
        this.textView_ = _GEHelper.GEHelper.textHelper.newText('asdf', this.FONT, '#000000', 'alphabetic');
        this.textView_.x = 4;
        if (_GEHelper.GEHelper.isWebGL) {
          this.textView_.y = this.GL_VAR_POS.LABEL_Y;
        } else {
          this.textView_.y = 2.5;
        }
        this.view_.addChild(this.textView_);
        this.valueView_ = _GEHelper.GEHelper.textHelper.newText('asdf', this.VALUE_FONT, '#ffffff', 'alphabetic');
        var variableLength = Entry.variableContainer.variables_.length;
        var _VariableBP$add = VariableBP.add(this.id_, this.x_, this.y_, this.getRealWidth(), this.getRealHeight()),
          x = _VariableBP$add.x,
          y = _VariableBP$add.y;
        if (this.getX() && this.getY()) {
          this.setX(this.getX());
          this.setY(this.getY());
        } else {
          //TODO
          // console.log(10 - 240 + Math.floor((variableLength % 66) / 11) * 80, x);
          // console.log(
          //     variableIndex * 28 + 20 - 135 - Math.floor(variableLength / 11) * 264,
          //     y
          // );
          this.setX(x - 230);
          this.setY(y - 105);
          // this.setX(10 - 240 + Math.floor((variableLength % 66) / 11) * 80);
          // this.setY(variableIndex * 28 + 20 - 135 - Math.floor(variableLength / 11) * 264);
        }
        this.view_.addChild(this.valueView_);
        if (Entry.type === 'workspace') {
          this.view_.cursor = 'move';
        }
        this.view_.on(_GEDragHelper.GEDragHelper.types.DOWN, function (evt) {
          if (Entry.type !== 'workspace') {
            return;
          }
          this.offset = {
            x: this.x - (evt.stageX * 0.75 - 240),
            y: this.y - (evt.stageY * 0.75 - 135)
          };
        });
        this.view_.on(_GEDragHelper.GEDragHelper.types.MOVE, function (evt) {
          if (Entry.type !== 'workspace') {
            return;
          }
          this.variable.setX(evt.stageX * 0.75 - 240 + this.offset.x);
          this.variable.setY(evt.stageY * 0.75 - 135 + this.offset.y);
          this.variable.updateView();
        });
      }
      this.setVisible(this.isVisible());
      Entry.stage.loadVariable(this);
    }

    /**
     * this.view_ 를 수정 후, 엔트리에 새로 그리기 요청을 한다.
     * generateView 혹은 updateView 가 이상하게 그려진다면, 혹시 variableType 이 잘못되었는지 확인.
     */
  }, {
    key: "updateView",
    value: function updateView() {
      if (!this.view_) {
        return;
      }
      if (this.isVisible()) {
        this._adjustSingleViewPosition();
        var oldContent = this.textView_.text;
        var newContent;
        if (this.object_) {
          var obj = Entry.container.getObject(this.object_);
          if (obj) {
            newContent = "".concat(obj.name, ":").concat(this.getName());
          } else {
            newContent = this.getName();
          }
        } else {
          newContent = this.getName();
        }
        if (oldContent !== newContent) {
          this.textView_.text = newContent;
          this._nameWidth = null;
        }
        if (this.isNumber()) {
          if (this.value_[0] !== 0 && Entry.isInteger(this.value_)) {
            this.valueView_.text = "".concat(this.getValue());
          } else {
            this.valueView_.text = Number(this.getValue()).toFixed(2).replace('.00', '');
          }
        } else {
          this.valueView_.text = this.getValue();
        }
        if (this._nameWidth === null) {
          this._nameWidth = this.textView_.getMeasuredWidth();
        }
        this._adjustSingleValueViewPosition();

        // INFO: Number체크는 slide 일때만 하도록 처리 기본 문자로 처리함(#4876)

        if (this._valueWidth === null) {
          this._valueWidth = this.valueView_.getMeasuredWidth();
        }
        var colorSet = EntryStatic.colorSet.canvas || {};
        this._adjustSingleViewBox(colorSet.variable || '#4f80ff');
      }
      bpReplace(this.id_, this.x_, this.y_, this.getRealWidth(), this.getRealHeight());
      Entry.requestUpdate = true;
    }

    /**
     * stage 내 변수 / 타이머 / 대답 뷰의 크기와 위치를 조정한다.
     * wrapper 의 이미지는 동일하다.
     * rr(RectRadius) 의 인자는 각각 x, y, width, height, radius
     * @param {string} boxFillAndStrokeColor
     * @protected
     */
  }, {
    key: "_adjustSingleViewBox",
    value: function _adjustSingleViewBox(boxFillAndStrokeColor) {
      // TODO slider updateView 만 rect_.graphics 를 따로 씀. rr 인자 constants 로 묶을 것.
      var colorSet = EntryStatic.colorSet.canvas || {};
      this.rect_.graphics.clear().f('#ffffff').ss(1, 2, 0).s(colorSet.border || '#aac5d5').rr(0, -14, this._nameWidth + this._valueWidth + 35, 24, 4);
      this.wrapper_.graphics.clear().f(boxFillAndStrokeColor).ss(1, 2, 0).s(boxFillAndStrokeColor).rr(this._nameWidth + 14, -10, this._valueWidth + 15, 16, this.RECT_RADIUS);
    }
  }, {
    key: "_adjustSingleViewPosition",
    value: function _adjustSingleViewPosition() {
      this.view_.x = this.getX();
      this.view_.y = this.getY();
    }
  }, {
    key: "_adjustSingleValueViewPosition",
    value: function _adjustSingleValueViewPosition() {
      this.valueView_.x = this._nameWidth + 21;
      if (_GEHelper.GEHelper.isWebGL) {
        this.valueView_.y = this.GL_VAR_POS.VALUE_Y;
      } else {
        this.valueView_.y = 1.5;
      }
    }

    /**
     * Variable name getter
     * @return {string}
     */
  }, {
    key: "getName",
    value: function getName() {
      return this.name_;
    }

    /**
     * Variable name setter
     * @param {!string} variableName
     */
  }, {
    key: "setName",
    value: function setName(variableName) {
      Entry.assert(typeof variableName === 'string', 'Variable name must be string');
      this.name_ = variableName;
      this._nameWidth = null;
      this.updateView();
      Entry.requestUpdateTwice = true;
    }

    /**
     * Variable id getter
     * @return {string}
     */
  }, {
    key: "getId",
    value: function getId() {
      return this.id_;
    }
  }, {
    key: "setId",
    value: function setId(id) {
      this.id_ = id;
    }

    /**
     * Variable value getter
     * @return {number}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      if (!this.isRealTime_) {
        return this.value_;
      } else {
        var _ref = this.cloudVariable.get({
            variableType: this.type,
            id: this.id_
          }) || {},
          value = _ref.value;
        return value || this.value_;
      }
    }

    /**
     * Verify value is number
     * @return {boolean}
     */
  }, {
    key: "isNumber",
    value: function isNumber() {
      return Entry.Utils.isNumber(this.value_);
    }

    /**
     * Variable value setter
     * @param {!string} variableValue
     */
  }, {
    key: "setValue",
    value: function setValue(value) {
      var _this = this;
      if (!this.isRealTime_) {
        this.value_ = value;
        this._valueWidth = null;
        this.updateView();
        Entry.requestUpdateTwice = true;
      } else {
        return new Promise(/*#__PURE__*/function () {
          var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(resolve, reject) {
            var _t;
            return _regenerator["default"].wrap(function (_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;
                  _context.next = 1;
                  return _this.cloudVariable.set({
                    variableType: _this.type,
                    id: _this.id_
                  }, value);
                case 1:
                  _this.value_ = value;
                  _this._valueWidth = null;
                  _this.updateView();
                  Entry.requestUpdateTwice = true;
                  resolve();
                  _context.next = 3;
                  break;
                case 2:
                  _context.prev = 2;
                  _t = _context["catch"](0);
                  reject(_t);
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee, null, [[0, 2]]);
          }));
          return function (_x, _x2) {
            return _ref2.apply(this, arguments);
          };
        }());
      }
    }

    /**
     * Variable visible state getter
     * @return {boolean}
     */
  }, {
    key: "isVisible",
    value: function isVisible() {
      return this.visible_;
    }

    /**
     * Variable visible state setter
     * @param {!boolean} visibleState
     */
  }, {
    key: "setVisible",
    value: function setVisible(visibleState) {
      Entry.assert(typeof visibleState === 'boolean', 'Variable visible state must be boolean');
      if (this.visible_ === visibleState) {
        return;
      }
      this.view_.visible = visibleState;
      this.visible_ = visibleState;
      this.updateView();
    }

    /**
     * X coordinate setter
     * @param {number} x
     */
  }, {
    key: "setX",
    value: function setX(x) {
      /** @type {number} */
      this.x_ = x;
      this.updateView();
    }

    /**
     * X coordinate getter
     * @return {number}
     */
  }, {
    key: "getX",
    value: function getX() {
      return this.x_;
    }

    /**
     * Y coordinate setter
     * @param {number} y
     */
  }, {
    key: "setY",
    value: function setY(y) {
      /** @type {number} */
      this.y_ = y;
      this.updateView();
    }

    /**
     * Y coordinate getter
     * @return {number}
     */
  }, {
    key: "getY",
    value: function getY() {
      return this.y_;
    }

    /**
     * width setter
     * @param {number} width
     */
  }, {
    key: "setWidth",
    value: function setWidth(width) {
      /** @type {number} */
      this.width_ = width < 100 ? 100 : width;
      this.updateView();
    }

    /**
     * width getter
     * @return {number}
     */
  }, {
    key: "getWidth",
    value: function getWidth() {
      return this.width_;
    }
  }, {
    key: "getRealWidth",
    value: function getRealWidth() {
      return Math.ceil(this.textView_.getMeasuredWidth(this.name_) + this.textView_.getMeasuredWidth(this.getValue()) + 40);
    }

    /**
     * height setter
     * @param {number} height
     */
  }, {
    key: "setHeight",
    value: function setHeight(height) {
      /** @type {number} */
      this.height_ = height < 100 ? 100 : height;
      this.updateView();
    }

    /**
     * height getter
     * @return {number}
     */
  }, {
    key: "getHeight",
    value: function getHeight() {
      return this.height_;
    }
  }, {
    key: "getRealHeight",
    value: function getRealHeight() {
      return Math.ceil(this.textView_.getMeasuredHeight() + 12);
    }

    /**
     * save current state data to 'snapshot_'
     */
  }, {
    key: "takeSnapshot",
    value: function takeSnapshot() {
      this.snapshot_ = this.toJSON();
    }

    /**
     * load snapshot to current variable
     */
  }, {
    key: "loadSnapshot",
    value: function loadSnapshot() {
      this.snapshot_ && this.syncModel_(this.snapshot_);
      delete this.snapshot_;
    }

    /**
     * sync this model with parameter
     * @param {!entity model}variableModel
     * @protected
     */
  }, {
    key: "syncModel_",
    value: function syncModel_(variableModel) {
      if (!this.isCloud_ && !this.isRealTime_) {
        this.setValue(variableModel.value);
      }
      this.setName(variableModel.name);
      this.setX(variableModel.x);
      this.setY(variableModel.y);
      this.setVisible(variableModel.visible);
      this.isCloud_ = variableModel.isCloud;
      this.isRealTime_ = variableModel.isRealTime;
      this.cloudDate = variableModel.cloudDate;
    }

    /**
     * convert this variable's data to JSON.
     * @return {JSON}
     */
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      json.name = this.name_;
      json.id = this.id_;
      json.visible = this.visible_;
      json.value = this.value_;
      json.variableType = this.type;
      json.isCloud = this.isCloud_;
      json.isRealTime = this.isRealTime_;
      json.cloudDate = this.cloudDate;
      json.object = this.object_;
      json.x = this.x_;
      json.y = this.y_;
      return json;
    }

    /**
     * Remove self
     */
  }, {
    key: "remove",
    value: function remove() {
      //this.parent.dialog = null;
      VariableBP.remove(this.id_);
      Entry.stage.removeVariable(this);
    }

    /**
     * clone self
     */
  }, {
    key: "clone",
    value: function clone() {
      return Entry.Variable.create((0, _extends2["default"])(this.toJSON(), {
        isClone: true
      }));
    }
  }, {
    key: "getType",
    value: function getType() {
      return this.type;
    }
  }, {
    key: "getMinValue",
    value: function getMinValue() {
      return this.minValue_;
    }
  }, {
    key: "setMinValue",
    value: function setMinValue(value) {
      this._valueWidth = null;
      var minValue = value || 0;
      this.minValue_ = minValue;
      if (this.value_ < minValue) {
        this.setValue(minValue);
      }
      this.isMinFloat = Entry.isFloat(this.minValue_);
      this.updateView();
    }
  }, {
    key: "getMaxValue",
    value: function getMaxValue() {
      return this.maxValue_;
    }
  }, {
    key: "setMaxValue",
    value: function setMaxValue(value) {
      this._valueWidth = null;
      var maxValue = value || 100;
      this.maxValue_ = maxValue;
      if (this.value_ > maxValue) {
        this.value_ = maxValue;
      }
      this.isMaxFloat = Entry.isFloat(this.maxValue_);
      this.updateView();
    }
  }, {
    key: "isFloatPoint",
    value: function isFloatPoint() {
      return this.isMaxFloat || this.isMinFloat;
    }
  }, {
    key: "getCloudDate",
    value: function getCloudDate() {
      return this.cloudDate;
    }
  }, {
    key: "setCloudDate",
    value: function setCloudDate(cloudDate) {
      this.cloudDate = cloudDate;
    }
  }, {
    key: "getArray",
    value: function getArray() {
      return this.array_;
    }
  }, {
    key: "setArray",
    value: function setArray(array) {
      this.array_ = array;
      this.updateView();
      Entry.requestUpdateTwice = true;
    }
  }]);
}(); // Entry.Variable = Variable;
// add export
var _default = exports["default"] = Variable;